/* eslint-disable global-require */

export default {
  navigations: [
    {
      name: 'Institute profile',
      path: 'profile'
    },
    {
      name: 'Research leader',
      path: 'leader'
    },
    {
      name: 'Office',
      path: 'office'
    },
  ],
  article: {
    title: 'Hello everyone!<br/>Here is the Artificial Intelligence Institute, Shanghai Jiao Tong University!',
    content: [
      {
        description: 'Artificial Intelligence is profoundly changing the pattern of social and economic development. Faced with the strategic deployment of China and Shanghai, Shanghai Jiao Tong University gathers internal and external resources and founded the Institute of Artificial Intelligence (hereinafter referred to as "the Institute") on Jan.18, 2018, seizing the major strategic opportunity for AI development.',
        position: 'first',
      },
      {
        title: 'Basic Function',
        description: 'As the AI research entity of Shanghai Jiao Tong University, the Institute accelerates the building of research team，actively organizes the construction of research center and coordinates the scientific research in AI field on campus，becoming a unified export of the school’s foreign exchange and transformation of scientific research achievements.'
      },
      {
        title: 'Development Foundation',
        description: 'Shanghai Jiao Tong University has a solid foundation in AI disciplines. According to 2020 QS World University Discipline ranking, Shanghai Jiao Tong University ranks 34th in Computer Science & Information Systems, 29th in Engineering - Electrical & Electronic and 39th in Mathematics; In the fourth National First-level disciplinary assessment, three disciplines of Computer Science and Technology, Information and Communication Engineering, Control Science and Engineering, which support the core theory of AI, have all received A ratings.<br/>' +
          'Shanghai Jiao Tong University has built a high-level teaching team of about 50 people in AI field (more than 30 national talents), including 3 academicians of the Chinese Academy of Sciences and Chinese Academy of Engineering, 4 IEEE fellows, 2 Yangtze River Distinguished Professors and 4 winners of NSFC Distinguished Young Scholars.'
      },
      {
        title: 'Construction Content',
        description: 'As an interdisciplinary platform for the school’s AI research, the Institute actively integrates the research forces of relevant departments and disciplines in AI field，adheres to high standards and high positioning, and builds several research centers to form an AI innovation ecosystem with the school’s features and to build itself a world-class AI research institute.',
      },
      {
        title: 'Construction Goal',
        description: 'By 2025, the institute will have gathered a group of world-class talents, strengthened personnel training and constructed innovation ecosystem respectively to become the world’s highland of AI academic research, AI talents and AI achievements transformation.'
      }
    ]
  },
  offices: [
    {
      name: 'Xiaohui DU',
      responsibility: 'Personnel / Publicity / Finance',
      phone: '34206041',
      address: 'Room 5-503, Software Building, Shanghai Jiao Tong University',
      email: 'duxiaohui2010@sjtu.edu.cn',
    },
    {
      name: 'Leiyu HUANG',
      responsibility: '',
      phone: '34206041',
      address: 'Room 5-503, Software Building, Shanghai Jiao Tong University',
      email: '1627hly@sjtu.edu.cn',
    },
    {
      name: 'Jiaojiao ZHENG',
      responsibility: '',
      phone: '34206041',
      address: 'Room 5-503, Software Building, Shanghai Jiao Tong University',
      email: 'zhengjiaojiao@sjtu.edu.cn',
    },
  ],
  leaders: [
    // {
    //   name: 'Hong MEI',
    //   titles: 'Dean',
    //   duties: '',
    //   honours: '',
    //   avator: '',
    // },
    {
      name: 'Xiaokang YANG',
      titles: 'Executive Deputy Dean',
      duties: '',
      honours: '',
      avator: '',
    },
    {
      name: 'Lei XU',
      titles: 'Chief Scientist',
      duties: '',
      honours: '',
      avator: '',
    },
    {
      name: 'Fan JIANG',
      titles: 'Deputy Dean',
      duties: '',
      honours: '',
      avator: '',
    },
    {
      name: 'Lizhuang MA',
      titles: 'Deputy Dean',
      duties: '',
      honours: '',
      avator: '',
    },
    {
      name: 'Xi ZHANG',
      titles: 'Deputy Dean',
      duties: '',
      honours: '',
      avator: '',
    },
    {
      name: 'Yanfeng WANG',
      titles: 'Deputy Dean',
      duties: '',
      honours: '',
      avator: '',
    },
    {
      name: 'Haitao SONG',
      titles: 'Deputy Dean',
      duties: '',
      honours: '',
    },
    {
      name: 'Yaohui JIN',
      titles: 'Chief Engineer',
      duties: '',
      honours: '',
    },
    {
      name: 'Liming HE',
      titles: 'Assistant Dean',
      duties: '',
      honours: '',
    }
  ],
  successive_title: 'Previous leaders',
  successive: [
    {
      name: 'Junfa MAO',
      title: 'Academician of Chinese Academy of Sciences',
      text: 'Dean of Artificial Intelligence Institute from January 2018 to June 2019',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/utils/lang/about.en.js